import { render } from "./index.vue?vue&type=template&id=dcfd0392&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=dcfd0392&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-dcfd0392"

export default script